export const CarIcon = ({ className, color = 'white' }) => {
  return (
    <svg
      className={className}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1690_100774)">
        <path
          d="M2.17188 11.376H23.1719"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6719 17.376V19.626C21.6719 19.8249 21.5929 20.0157 21.4522 20.1563C21.3116 20.297 21.1208 20.376 20.9219 20.376H18.6719C18.473 20.376 18.2822 20.297 18.1415 20.1563C18.0009 20.0157 17.9219 19.8249 17.9219 19.626V17.376"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.42188 17.376V19.626C7.42188 19.8249 7.34286 20.0157 7.2022 20.1563C7.06155 20.297 6.87079 20.376 6.67188 20.376H4.42188C4.22296 20.376 4.0322 20.297 3.89155 20.1563C3.75089 20.0157 3.67188 19.8249 3.67188 19.626V17.376"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.67188 14.376H8.17188"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1719 14.376H18.6719"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6719 11.376L18.8697 5.07129C18.8108 4.93874 18.7147 4.82612 18.593 4.74708C18.4714 4.66805 18.3294 4.62598 18.1844 4.62598H7.15937C7.01432 4.62598 6.87237 4.66805 6.75073 4.74708C6.6291 4.82612 6.53299 4.93874 6.47406 5.07129L3.67188 11.376V17.376H21.6719V11.376Z"
          stroke={color}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1690_100774">
          <rect
            width="24"
            height="24"
            fill={color}
            transform="translate(0.671875 0.125977)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
